var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import "./CheckBoxStyle.scss";
import { EventHandler } from "../../interaction/eventhandler";
import { helper } from "../../core/helper";
var CheckBoxComponent = /** @class */ (function () {
    function CheckBoxComponent(options) {
        var _a;
        this.options = __assign({ enabled: true, class: "", bindMode: "toModel" }, options);
        if (!this.options.id) {
            this.options.id = helper.newDomGuid();
        }
        if (this.options.bindTo != null && this.options.property != null && this.options.value == null) {
            this.options.value = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
        }
        this.options.onChange = EventHandler.Create(this.options.onChange);
    }
    Object.defineProperty(CheckBoxComponent.prototype, "onChange", {
        get: function () {
            return this.options.onChange;
        },
        enumerable: false,
        configurable: true
    });
    // public isEqual(node: IJSLComponent): boolean {
    //     return (this as any).__proto__ === (node as any).__proto__;
    // }
    CheckBoxComponent.prototype.render = function () {
        var _a;
        var val = this.options.value;
        if (this.options.bindMode !== "toModel" && this.options.bindTo != null && this.options.property != null) {
            var current = this.getValue();
            var newVal = (((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toUI) ?
                this.options.converter.toUI(this.options.bindTo[this.options.property]) :
                this.options.bindTo[this.options.property]);
            if (newVal !== current) {
                val = newVal;
                if (this.currentDom != null) {
                    this.currentDom.checked = val;
                }
            }
        }
        return {
            tag: "span",
            attr: { style: this.options.style },
            children: [{
                    tag: "input",
                    attr: {
                        type: "checkbox",
                        disabled: !this.options.enabled ? "disabled" : undefined,
                        class: "checkbox-comp " + (this.options.class || ""),
                        change: this.raiseEvent,
                        checked: val ? "checked" : undefined,
                        id: typeof this.options.id === "string" ? this.options.id : undefined
                    }
                }, { tag: "label", content: this.options.label, attr: { for: this.options.id } }]
        };
    };
    CheckBoxComponent.prototype.getValue = function () {
        var _a;
        return ((_a = this.currentDom) === null || _a === void 0 ? void 0 : _a.checked) || false;
    };
    CheckBoxComponent.prototype.setValue = function (val) {
        var _a;
        if (this.currentDom != null) {
            this.currentDom.checked = val;
        }
        if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) {
            this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(val) : val;
        }
    };
    CheckBoxComponent.prototype.onCreate = function (node) {
        this.currentDom = node.dom.querySelector("input");
    };
    CheckBoxComponent.prototype.raiseEvent = function (e, node) {
        var _a;
        if (this.options.enabled) {
            var value = node.dom.checked;
            if (this.options.bindTo && this.options.bindMode !== "fromModel" && this.options.property) {
                this.options.bindTo[this.options.property] = ((_a = this.options.converter) === null || _a === void 0 ? void 0 : _a.toData) ? this.options.converter.toData(value) : value;
            }
            this.options.onChange.notify(value);
        }
    };
    return CheckBoxComponent;
}());
export { CheckBoxComponent };
